import React, { useState } from "react";

const LearningPathTFD = () => {
  const [toggleAllSections, setToggleAllSections] = useState(false);
  const [sectionToggle, setSectionToggle] = useState({});
  const [toggleNewModule, setToggleNewModule] = useState(false);
  const [newModuleToggle, setNewModuleToggle] = useState({});
  const [toggleExteraModule, setToggleExteraModule] = useState(false);
  const [exteraModuleToggle, setExteraModuleToggle] = useState({});
  const [toggleIsExteraModule, setToggleIsExteraModule] = useState(false);
  const [isExteraModuleToggle, setIsExteraModuleToggle] = useState({});
  const [toggleAdditionalModule, setToggleAdditionalModule] = useState(false);
  const [additionalModuleToggle, setAdditionalModuleToggle] = useState({});
  const [toggleExtraAdvancedModule, setToggleExtraAdvancedModule] = useState(false);
  const [extraAdvancedModuleToggle, setExtraAdvancedModuleToggle] = useState({});
  const [toggleAndLocalModule, setToggleAndLocalModule]= useState(false);
  const [AndLocalModuleToggle, setAndLocalModuleToggle]= useState({});
  const [toggleAndUlteraLocalModule, setToggleAndUlteraLocalModule]= useState(false);
  const [AndUlteraLocalModuleToggle, setAndUlteraLocalModuleToggle]= useState({});
  const listContent = [
    // Existing sections
    {
      id: 1,
      title: "Overview of Flutter",
      nestedContent: [
        { id: 1, text: "• 		History and features of Flutter.", dummyText: [] },
        { id: 2, text: "•		Setting up the development environment (IDE: Android Studio, VS Code).", dummyText: [] },
        { id: 3, text: "• 	Flutter project structure and understanding the widget tree.", dummyText: [] },
      ],
    },
    {
      id: 2,
      title: "Basic Syntax and Structure",
      nestedContent: [
        { id: 1, text: "• 	Writing and running a simple Flutter app.", dummyText: [] },
        { id: 2, text: "• 	Understanding widgets (Stateless and Stateful).", dummyText: [] },
        { id: 3, text: "• 	Variables, data types, and basic Dart syntax.", dummyText: [] },
       
      ],
    },
    {
        id: 3,
        title: "Layouts and UI Design",
        nestedContent: [
          { id: 1, text: "• 	Flutter layout basics (Row, Column, Stack).", dummyText: [] },
          { id: 2, text: "• 	Using Containers, Padding, and Align widgets.", dummyText: [] },
          { id: 3, text: "• 	Building responsive UIs with Flex, Expanded, and MediaQuery.", dummyText: [] },
         
        
        ],
      },
      
  ];

  const newModuleContent = [
    // New module sections
    {
      id: 1,
      title: " Core Dart Concepts",
      nestedContent: [
        { id: 1, text: "• 	Variables, data types, operators, functions, and loops.", dummyText: [] },
        { id: 2, text: "• 	Conditional statements (if, else, switch, for, while, do-while).", dummyText: [] },
       
      ],
    },
    {
      id: 2,
      title: " Object-Oriented Programming (OOP)",
      nestedContent: [
        { id: 1, text: "•	Classes, objects, constructors, getters, and setters.", dummyText: [] },
        { id: 2, text: "•	Inheritance, polymorphism, and abstraction.", dummyText: [] },
        { id: 3, text: "•	Mixins and extensions.", dummyText: [] },
       
      ],
    },
    {
        id: 3,
        title: " Asynchronous Programming",
        nestedContent: [
          { id: 1, text: "•	Futures, async/await, and streams for handling async tasks.", dummyText: [] },
          { id: 2, text: "•	Error handling (try-catch, custom exceptions).", dummyText: [] },
         
        ],
      },
      
     
      
  ];

  const exteraModuleContent = [
    // Extra module sections
    {
      id: 3,
      title: " Basic Widgets",
      nestedContent: [
        { id: 1, text: "•	Text, Button, Image, Icon, and other essential widgets.", dummyText: [] },
        { id: 2, text: "•	Custom widgets and widget composition.", dummyText: [] },
        
       
       
      ],
    },
    {
      id: 4,
      title: " Layouts in Flutter",
      nestedContent: [
        { id: 1, text: "•	Using Row, Column, Stack, and ListView.", dummyText: [] },
        { id: 2, text: "•	Responsive design with MediaQuery and LayoutBuilder.", dummyText: [] },
        { id: 3, text: "•	Building adaptive layouts for different screen sizes.", dummyText: [] },
        
      ],
    },
    {
        id: 5,
        title: " State Management",
        nestedContent: [
          { id: 1, text: "•	Introduction to state management (setState, Provider, Riverpod, Bloc).", dummyText: [] },
          { id: 2, text: "•	Managing local and global app state.", dummyText: [] },
          
        ],
      },
     
  ];

  const additionalModuleContent = [
    // Additional module sections
    {
      id: 5,
      title: " Navigation Basics",
      nestedContent: [
        { id: 1, text: "•	Understanding Flutter’s navigation model", dummyText: [] },
        { id: 2, text: "•	Pushing and popping routes, passing data between screens.", dummyText: [] },
      ],
    },
    {
      id: 6,
      title: "Advanced Routing",
      nestedContent: [
        { id: 1, text: "•	Named routes and route parameters.", dummyText: [] },
        { id: 2, text: "•	Implementing deep linking in Flutter.", dummyText: [] },
        { id: 3, text: "•	Creating custom navigation solutions.", dummyText: [] },
      ],
    },
    {
        id: 7,
        title: "Persistent Navigation",
        nestedContent: [
          { id: 1, text: "• 		Using BottomNavigationBar, Drawer, and TabBar for persistent navigation.", dummyText: [] },
        
        ],
      },
      
      
      
  ];

  const isExteraModuleContent = [
    // Additional Module Sections
    {
      id: 7,
      title: " Networking Basics",
      nestedContent: [
        { id: 1, text: "•	Making HTTP requests using the http package.", dummyText: [] },
        { id: 2, text: "•	Parsing JSON data.", dummyText: [] },
        { id: 3, text: " •	Handling network errors and retries.", dummyText: [] },

       
      ],
    },
    {
      id: 8,
      title: " Authentication and APIs",
      nestedContent: [
        { id: 1, text: "•	Implementing user authentication (Firebase, OAuth).", dummyText: [] },
        { id: 2, text: "•	Making requests to RESTful APIs.", dummyText: [] },
        { id: 3, text: "•	Sending and receiving data securely.", dummyText: [] },
      ],
    },
    {
        id: 9,
        title: "Data Persistence",
        nestedContent: [
          { id: 1, text: "•	Local storage using SharedPreferences, SQLite.", dummyText: [] },
          { id: 2, text: "•	Firebase Firestore integration for real-time data.", dummyText: [] },
        ],
      },
      
      
      
  ];

  const extraAdvancedModuleContent = [
    // Extra Advanced Module Sections
    {
      id: 9,
      title: "  Introduction to Flutter Animations",
      nestedContent: [
        { id: 1, text: "•	Basics of Flutter animation framework.", dummyText: [] },
        { id: 2, text: "•	Implicit and explicit animations.", dummyText: [] },
        { id: 3, text: " •	Animating widgets and transitions.", dummyText: [] },
      ],
     
    },
    {
      id: 10,
      title: " Advanced UI Design",
      nestedContent: [
        { id: 1, text: "• 			Customizing themes and styles.", dummyText: [] },
        { id: 2, text: "•	Building custom animations (Tween, Curves, AnimationController).", dummyText: [] },
        { id: 3, text: " •	Designing complex UI components like charts, graphs, and custom widgets.", dummyText: [] },
      ],
     

    },
    {
      id: 11,
      title: "Responsive Design",
      nestedContent: [
        { id: 1, text: "•	Building responsive UIs for different screen sizes and platforms.", dummyText: [] },
        { id: 2, text: "•	Using LayoutBuilder and MediaQuery for adaptive layouts.", dummyText: [] },
       
      ],
    },
    
  ];

  const andLocalModuleContent = [
    //ExtraAdvancedModuleSections
    {
      id: 13,
      title: " Unit and Widget Testing",
      nestedContent: [
        { id: 1, text: "	•	Writing unit tests with the test package.", dummyText: [] },
        { id: 2, text: "•	Writing widget tests using flutter_test.", dummyText: [] },
        { id: 3, text: "•	Mocking and dependency injection in tests.", dummyText: [] },
      ],
    },
    {
      id: 14,
      title: " Debugging Flutter Apps",
      nestedContent: [
        { id: 1, text: "•	Using Flutter DevTools for debugging", dummyText: [] },
        { id: 2, text: "•	Identifying and resolving performance bottlenecks.", dummyText: [] },
        { id: 3, text: "•	Inspecting widget rebuilds and optimizing app performance.", dummyText: [] },
       
      ],
    },
    {
      id: 15,
      title: "  Continuous Integration and Deployment (CI/CD)",
      nestedContent: [
        { id: 1, text: "•	Setting up CI/CD pipelines for Flutter projects using tools like Codemagic, GitHubActions, or Bitrise. ", dummyText: [] },
        { id: 2, text: "•		Automating builds and deployments to the Play Store and App Store. ", dummyText: [] },
      ],
    },
    
  ];
  const andUlteraLocalModuleContent = [
    //ExtraAdvancedModuleSections
    
    {
        id: 16,
        title: "  Project Requirements: ",
        nestedContent: [
          { id: 1, text: "• 					Design and develop a multi-screen Flutter application.", dummyText: [] },
          { id: 2, text: "• 					Implement local storage and API integration (Firebase or RESTful API).", dummyText: [] },
          { id: 3, text: "• 						Build a responsive UI using Flutter’s layout system", dummyText: [] },
          { id: 4, text: "• 						Apply state management techniques (Provider, Riverpod, or Bloc).", dummyText: [] },
          { id: 5, text: "• 							Integrate animations and advanced UI features.", dummyText: [] },
          { id: 6, text: "• 						Write unit tests and widget tests for critical app features.", dummyText: [] },
          { id: 7, text: "• 							Deploy the app to Google Play Store and/or Apple App Store (optional).", dummyText: [] },
          { id: 8, text: "• 							Document and present the project.", dummyText: [] },
        ],
      },
    
  ];

  const toggleSection = (id, module = "existing") => {
    if (module === "existing") {
      setSectionToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "new") {
      setNewModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extera") {
      setExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "isextera") {
      setIsExteraModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "additional") {
      setAdditionalModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    } else if (module === "extraAdvanced") {
      setExtraAdvancedModuleToggle((prev) => ({ ...prev, [id]: !prev[id] }));
    }else if (module === "andLocal"){
        setAndLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
   } else if (module === "andUlteraLocal"){
    setAndUlteraLocalModuleToggle((prev) => ({...prev,[id]: !prev[id]}));
  }
  };
  
  return (
    <div className="container my-5">
      <h2 className="fw-bold mb-4" style={{ color: "#000", fontFamily: "Roboto", textAlign: "center",marginTop:'30px', }}>
        Flutter <span style={{ color: "rgb(251 145 0)" }}>Program</span>
      </h2>
      <br />
      
      {/* Existing Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAllSections(!toggleAllSections)}
      >
        Introduction to Flutter
      </div>

      {toggleAllSections && (
        <div className="list-tab mt-3">
          {listContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id)}
              >
                {title}
                <span>{sectionToggle[id] ? "-" : "+"}</span>
              </div>
              {sectionToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* New Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleNewModule(!toggleNewModule)}
      >
      Dart Programming for Flutter
      </div>

      {toggleNewModule && (
        <div className="list-tab mt-3">
          {newModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "new")}
              >
                {title}
                <span>{newModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {newModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Extera Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExteraModule(!toggleExteraModule)}
      >
        Flutter UI and Widgets
      </div>

      {toggleExteraModule && (
        <div className="list-tab mt-3">
          {exteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extera")}
              >
                {title}
                <span>{exteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {exteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Additional Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAdditionalModule(!toggleAdditionalModule)}
      >
        Navigation and Routing
      </div>

      {toggleAdditionalModule && (
        <div className="list-tab mt-3">
          {additionalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "additional")}
              >
                {title}
                <span>{additionalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {additionalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

<div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleIsExteraModule(!toggleIsExteraModule)}
      >
    Networking and APIs
      </div>

      {toggleIsExteraModule && (
        <div className="list-tab mt-3">
          {isExteraModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "isextera")}
              >
                {title}
                <span>{isExteraModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {isExteraModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      {/* Extra Advanced Module */}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleExtraAdvancedModule(!toggleExtraAdvancedModule)}
      >
     Flutter Animations and Advanced UI
      </div>

      {toggleExtraAdvancedModule && (
        <div className="list-tab mt-3">
          {extraAdvancedModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "extraAdvanced")}
              >
                {title}
                <span>{extraAdvancedModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {extraAdvancedModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
       <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAndLocalModule(!toggleAndLocalModule)}
      >
       Testing and Debugging
      </div>

      {toggleAndLocalModule && (
        <div className="list-tab mt-3">
          {andLocalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "andLocal")}
              >
                {title}
                <span>{AndLocalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {AndLocalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      <div
        className="fw-bold mb-4 p-3 bg-light rounded mt-5"
        style={{ color: "blue", fontFamily: "Roboto", fontSize: "20px", cursor: "pointer", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)" }}
        onClick={() => setToggleAndUlteraLocalModule(!toggleAndUlteraLocalModule)}
      >
       Final Project
      </div>

      {toggleAndUlteraLocalModule && (
        <div className="list-tab mt-3">
          {andUlteraLocalModuleContent.map(({ id, title, nestedContent }) => (
            <div key={id} className="mb-3">
              <div
                className="p-3 bg-light rounded d-flex justify-content-between align-items-center"
                style={{ boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)", fontFamily: "Roboto", fontSize: "18px", cursor: "pointer" }}
                onClick={() => toggleSection(id, "andUlteraLocal")}
              >
                {title}
                <span>{AndUlteraLocalModuleToggle[id] ? "-" : "+"}</span>
              </div>
              {AndUlteraLocalModuleToggle[id] && (
                <div className="mt-2 px-4">
                  {nestedContent.map(({ id: nestedId, text }) => (
                    <div key={nestedId} className="my-2">
                      <div className="p-2 bg-white rounded" style={{ border: "1px solid #ddd", fontFamily: "Roboto" }}>
                        {text}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LearningPathTFD;




